import { nameInitials } from "components/Scorecard/components/scorecardItem/nameInitials";
import { formatUserName } from "utils";
import Text from "components/Common/Text";
import PropTypes from "prop-types";

function EventDetails({
  courseName,
  profileImageUrl,
  firstName,
  lastName,
  share,

  title,
}) {
  return (
    <>
      <div>
        <Text as="H2" bold style={{ color: share ? "white" : "#232C2E" }}>
          ⛳ {title}
        </Text>
        <Text as="P3" style={{ color: share ? "#9BCFED" : "#5C6363" }}>
          {courseName}
        </Text>
      </div>
      <div
        style={{
          backgroundColor: "#F5F7F8",
          justifyContent: "space-between",
          borderRadius: 50,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          padding: "0px 10px 0px 10px",
        }}
      >
        <img
          src={
            profileImageUrl ||
            "https://i.ytimg.com/vi/zbeSiXXk-wI/hqdefault.jpg"
          }
          alt="User"
          style={{
            backgroundColor: "gray",
            height: 32,
            width: 32,
            borderRadius: 32,
            marginRight: 10,
            border: "1.5px solid #FFFFFF",
            objectFit: "cover",
          }}
        />

        <div>
          <Text as="C3" style={{ color: "#5C6363" }}>
            Created By
          </Text>
          <Text as="C1" style={{ color: "#232C2E" }}>
            {nameInitials(formatUserName(firstName, lastName))}
          </Text>
        </div>
      </div>
    </>
  );
}

export { EventDetails };

EventDetails.propTypes = {
  courseName: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  profileImageUrl: PropTypes.string,
  title: PropTypes.string,
  share: PropTypes.bool,
};

EventDetails.defaultProps = {
  share: false,
  courseName: "",
  firstName: "",
  lastName: "",
  profileImageUrl: "https://i.ytimg.com/vi/zbeSiXXk-wI/hqdefault.jpg",
  title: "",
};
